import { api } from '../../lib/api';
import type {
  SubmitReviewRequest,
  SubmitReviewResponse,
  PublicReview,
  PropertyRatingSummary,
} from '@pms/shared';

/** Real aggregate rating for a property (replaces the placeholder numbers). */
export async function getPropertyRating(
  propertyId: string,
): Promise<PropertyRatingSummary> {
  const { data } = await api.get<PropertyRatingSummary>(
    `/properties/${propertyId}/rating`,
  );
  return data;
}

/** Approved guest reviews for a property. */
export async function getPropertyReviews(
  propertyId: string,
): Promise<PublicReview[]> {
  const { data } = await api.get<PublicReview[]>(
    `/properties/${propertyId}/reviews`,
  );
  return data;
}

/** Submit a post-stay review (booking reference + PIN). */
export async function submitReview(
  body: SubmitReviewRequest,
): Promise<SubmitReviewResponse> {
  const { data } = await api.post<SubmitReviewResponse>('/reviews', body);
  return data;
}
